import {withDialog} from './withDialog';
import {DialogStyle} from './DialogStyle';

/** @component */
export const Dialog = withDialog(DialogStyle);
